const OthersContent = ({ children, title }: { children: React.ReactNode, title: string }) => {
  return (
    <>
      <div className="w-full max-w-[1100px] bg-[#E3E2E2] mx-auto mb-2 md:mb-6 rounded-xl text-left px-2 md:px-6 py-4 md:py-6 font-bold text-[13px] md:text-[24px]">
        <div className="flex justify-center items-center gap-x-2 w-[60%] md:w-[23rem] bg-white rounded-[5px] mb-4">
          <span className="bg-white  px-4 md:px-8 py-2 text-black text-[16px] md:text-[30px]">
            {title}
          </span>
        </div>
        {children}
      </div>
    </>
  );
}

export default OthersContent;